import script from "./backupStatusBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./backupStatusBar.vue?vue&type=script&setup=true&lang=ts"

import "./backupStatusBar.vue?vue&type=style&index=0&id=5eb636c6&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eb636c6"]])

export default __exports__